import type { ActionModuleResponse, BaseRewardCalculationTypeModel } from '@/api/model'
import { IncentivationSourceType } from '@/api/model/incentivationSourceType'
import { RewardCalculationType } from '@/api/model/rewardCalculationType'
import { IncentivationDataType } from '@/api/model/incentivationDataType'

/**
 * True when the module gets its incentivation manually AND allows bulk (Excel) upload —
 * the only case in which the Import/Export upload area is functional.
 */
export function isManualBulkUploadModule(module: ActionModuleResponse): boolean {
  const source = module.incentivationSource
  return (
    source?.type === IncentivationSourceType.ManualActionIncentivationSource &&
    source.canBulkUploadIncentivationData === true
  )
}

/** True when the module's reward calculation is score-range based (→ ScoreRanges panel). */
export function isScoreRangeModule(module: ActionModuleResponse): boolean {
  return module.rewardCalculationType?.type === RewardCalculationType.ScoreRangeCalculationType
}

/**
 * The incentivation data type the module produces (Score / ManualInput / Binary / None),
 * derived from the reward calculation type. Drives Excel column mapping and whether the
 * Score-development chart can be plotted.
 */
export function moduleIncentivationDataType(module: ActionModuleResponse): IncentivationDataType {
  // The union of calculation-type models all extend BaseRewardCalculationTypeModel; read
  // the shared `expectedIncentivationDataType` through the base type.
  const base = module.rewardCalculationType as BaseRewardCalculationTypeModel | null | undefined
  return base?.expectedIncentivationDataType ?? IncentivationDataType.None
}
